import classNames from "classnames";
import { ReactNode } from "react";
import { Outlet } from "react-router";

import styles from "./Steps.module.scss";

import { useAppSelector } from "../../store/hooks/hooks";
import { selectTemplateStep } from "../../store/slices/stepSlice";
import { Description } from "../Description";
import { Title } from "../Title";

export const Steps = () => {
  const step = useAppSelector(selectTemplateStep);

  return (
    <div className={styles.root}>
      <Title tagName={"h6"} className={styles.title}>
        STEP {step + 1}
      </Title>
      <div className={styles.wrapperSteps}>
        <span
          className={classNames(styles.step, {
            [styles.active]: step >= 0,
          })}
        />
        <span
          className={classNames(styles.step, {
            [styles.active]: step >= 1,
          })}
        />
        <span
          className={classNames(styles.step, {
            [styles.active]: step >= 2,
          })}
        />
        <span
          className={classNames(styles.step, {
            [styles.active]: step >= 3,
          })}
        />
        <span
          className={classNames(styles.step, {
            [styles.active]: step >= 4,
          })}
        />
      </div>
      <Outlet />
    </div>
  );
};

type StepsDescription = {
  [key: number]: ReactNode | string;
};

interface IStepsAlt {
  totalSteps: number;
  step: number;
  stepsDescription: StepsDescription;
  children?: ReactNode;
}

export const StepsAlt = ({
  totalSteps = 5,
  step = 1,
  stepsDescription,
  children
}: IStepsAlt) => {
  return (
    <div className={styles.root}>
      <Title tagName={"h5"} className={styles.title}>
        STEP {step + 1}
      </Title>
      <div className={styles.wrapperSteps}>
        {Array.from({ length: totalSteps }, (_, index) => (
          <span
          key={index}
          className={classNames(styles.step, {
            [styles.active]: step >= index,
          })}
          />
        ))}
      </div>
      <Description theme="t4">{stepsDescription[step]}</Description>
      {children}
    </div>
  );
};